import { Templates } from "./Templates";
import { appContainer } from "./templates/appContainerTemplates";
import { playerContainer } from "./templates/playerTemplates";
import { songMenuContainer } from "./templates/songMenuTemplates";

export class AppContainer {
	private _appContainer:HTMLDivElement;
	
	public get songMenuUi():HTMLDivElement {
		return this._songMenuUi;
	}
	private _songMenuUi:HTMLDivElement;
	
	public get playerUi():HTMLDivElement {
		return this._playerUi;
	}
	private _playerUi:HTMLDivElement;
	
	private _activeScreen:AppScreen;
	
	private static _ref:AppContainer;
	
	private constructor(){
		AppContainer._ref = this;
		this._init();
	}
	
	public static get():AppContainer {
		if (AppContainer._ref == null){
			new AppContainer();
		}
		return AppContainer._ref;
	}
	
	private _init():void {
		this._appContainer = Templates.createDiv(appContainer);
		document.body.append(this._appContainer);
		
		var qs = this._appContainer.querySelector.bind(this._appContainer);
		
		this._playerUi = Templates.createDiv(playerContainer);
		qs("#raac-player").append(this._playerUi);
		
		this._songMenuUi = Templates.createDiv(songMenuContainer);
		qs("#raac-menu").append(this._songMenuUi);
	}
	
	public setActiveScreen(screen:AppScreen):void {
		this._activeScreen = screen;
		this._updateDisplay();
	}
	
	private _updateDisplay():void {
		this._appContainer.classList.remove("menu");
		this._appContainer.classList.remove("player");
		
		let className:string;
		switch (this._activeScreen){
			case AppScreen.menu:
				className = "menu";
				break;
			
			case AppScreen.player:
				className = "player";
				break;
			
			case AppScreen.none:
				break;
		}
		
		if (className != null){
			this._appContainer.classList.add(className);
		}
	}
}

export enum AppScreen {
	none,
	menu,
	player
}